import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Role } from '../../../enums';
import { dataStore } from '../../../app.component';
import { MatIcon } from '@angular/material/icon';
import { MatCard } from '@angular/material/card';

@Component({
  selector: 'app-schedule-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  imports: [MatIcon, MatCard],
})
export class ScheduleLandingComponent implements OnInit {
  dataStore = dataStore;
  hasOwnSchedule = signal(false);
  canViewEmployeeList = signal(false);
  canViewAvailability = signal(false);

  constructor(private router: Router) {}

  ngOnInit() {
    const roles = dataStore.orgUser?.roles ?? [];
    const scheduleRoles = [Role.Driver, Role.CoDriver, Role.Planner, Role.RidePlanner];
    const hasOwnScheduleRole = roles.some((role) => scheduleRoles.includes(role));
    const canViewAvailability =
      dataStore.rootUser?.rights === 'admin' ||
      roles.includes(Role.Administrator) ||
      roles.includes(Role.Planner) ||
      roles.includes(Role.RidePlanner);
    const canViewEmployeeList =
      dataStore.rootUser?.rights === 'admin' ||
      roles.includes(Role.Administrator) ||
      roles.includes(Role.Planner);
    this.hasOwnSchedule.set(hasOwnScheduleRole);
    this.canViewEmployeeList.set(canViewEmployeeList);
    this.canViewAvailability.set(canViewAvailability);

    if (!hasOwnScheduleRole && !canViewAvailability) {
      this.router.navigate(['/schedule/employees'], { replaceUrl: true });
    }
  }

  goToOwnSchedule() {
    const roles = dataStore.orgUser?.roles ?? [];
    let type: string;
    if (roles.includes(Role.Driver)) {
      type = 'driver';
    } else if (roles.includes(Role.CoDriver)) {
      type = 'co-driver';
    } else {
      type = 'planner';
    }
    this.router.navigate(['/schedule', type, dataStore.rootUser.id], {
      state: { from: 'landing' },
    });
  }

  goToEmployeeList() {
    this.router.navigate(['/schedule/employees']);
  }

  goToAvailability() {
    this.router.navigate(['/schedule/availability']);
  }
}
